import {
    call,
    put,
    select,
    take,
    delay,
} from 'redux-saga/effects'

import ArbiterSelectors from 'common/modules/arbiter/selectors'
import { creators as ArbiterCreators } from 'common/modules/arbiter/actions'

import PopupQueue from 'common/modules/popupQueue'
import PopupTimer from 'common/modules/popupTimer'

import { run } from '../actions'

const runCreators = run.creators()

function* awaitTimerCompletion({ duration }) {
    yield put(
        yield call(
            PopupTimer.set,
            {
                payload: {
                    duration,
                    onDoneAction: {
                        type: 'POPUP_TIMER_HAS_COMPLETED',
                    },
                },
            },
        ),
    )

    let timerDone = false

    while (!timerDone) {
        const action = yield take('*')

        if (action.type === 'POPUP_TIMER_HAS_COMPLETED') {
            timerDone = true
        } else {
            const canShowPopup = yield select(ArbiterSelectors.canShowPopup)
            const isRunning = yield select(PopupTimer.isRunning)

            if (canShowPopup) {
                if (!isRunning) {
                    yield put(
                        yield call(
                            PopupTimer.start,
                        ),
                    )
                }
            } else if (isRunning) {
                yield put(
                    yield call(
                        PopupTimer.stop,
                    ),
                )
            }
        }
    }
}

function* awaitPromptDisplayed() {
    let promptDisplayed = false

    while (!promptDisplayed) {
        yield take('*')

        promptDisplayed = yield select(ArbiterSelectors.promptDisplayed)
    }
}

function* awaitPopupCompletion() {
    let canShowPopup = false
    let allFramesCreated = true

    while (!canShowPopup || allFramesCreated) {
        yield take('*')

        allFramesCreated = yield select(ArbiterSelectors.allFramesCreated)
        canShowPopup = yield select(ArbiterSelectors.canShowPopup)
    }
}

function* runPopupsProcessor({ popups } = {}) {
    try {
        let remainingPopups = yield select(PopupQueue.length)

        while (remainingPopups > 0) {
            const {
                id: popupId,
                trigger,
            } = yield select(PopupQueue.getFirst) || {}

            if (!popupId) {
                throw new Error('popup does not have an id')
            }

            const triggerType = trigger?.type
            const triggerValue = trigger?.value

            switch (triggerType) {
                case 'delay':
                    yield call(
                        awaitTimerCompletion,
                        {
                            duration: triggerValue,
                        },
                    )
                    break

                default:
                // do nothing
            }

            yield delay(0)

            yield put(
                yield call(
                    ArbiterCreators.showPopup,
                    {
                        popupId,
                    },
                ),
            )

            yield call(
                awaitPromptDisplayed,
            )

            yield call(
                awaitPopupCompletion,
            )

            yield put(
                yield call(
                    PopupQueue.remove,
                ),
            )

            remainingPopups = yield select(PopupQueue.length)
        }

        // after all popups have been processed...
        yield put(
            yield call(
                runCreators.runSuccess,
                {
                    payload: {
                        popups,
                    },
                },
            ),
        )
    } catch (error) {
        /* eslint-disable-next-line no-console */
        console.error(error)

        yield put(
            yield call(
                runCreators.runError,
                {
                    error,
                },
            ),
        )
    }
}

export default runPopupsProcessor
